export default {
  data() {
    return {
      screenSize: Object,
      setScreenSizeDebounced: _.debounce(this.setScreenSize, 50),
    };
  },

  methods: {
    /**
     * @return {undefined}
     */
    setScreenSize() {
      this.screenSize = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
    },
  },

  created() {
    this.setScreenSize();
    window.addEventListener('resize', this.setScreenSizeDebounced)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setScreenSizeDebounced)
  },
}
